import React from "react";

export default function SQL_PRIMARY_KEY() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_PRIMARY_KEY</h1>
      <p>This is the SQL_PRIMARY_KEY component generated from the SQL JSON.</p>
    </div>
  );
}
